<template>
    <div>
        <h3 class="text-center mb-8 mt-8 text-uppercase">Formulir Pelaporan Data</h3>
        <table class="table">
            <tr>
                <th scope="col" width="200">Unit</th>
                <td>{{ model.unit ? model.unit.name : '-' }}</td>
            </tr>
            <tr>
                <th scope="col" width="200">Terdiri dari</th>
                <td>{{ unitNames }}</td>
            </tr>
            <tr>
                <th scope="col">Tahun</th>
                <td>{{ model.year }}</td>
            </tr>
            <tr>
                <th scope="col">Deskripsi</th>
                <td>{{ model.description }}</td>
            </tr>
        </table>

        <div class="card-body p-4 table-responsive" v-if="!loading">
            <table class="table table-bordered table-sm table-fixed">
                <thead class="text-uppercase text-center valign-middle">
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col" class="width-200">Indikator</th>
                        <th scope="col" class="width-100">Target Indikator</th>
                        <th scope="col" colspan="2">Data yang dilaporkan</th>
                        <th scope="col" :colspan="(unitChildren.length+1)*12">Rekapitulasi Data {{ model.unit ? model.unit.name : '' }} Per Bulan Tahun  {{ model.year }}</th>
                        <th scope="col" class="width-100">Jumlah</th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <th scope="col" class="width-100" :colspan="unitChildren.length+1" :key="monthKey" v-for="(month, monthKey) in months">{{ month }}</th>
                        <th scope="col"></th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <template v-for="(_, key) in months">
                            <th scope="col" class="width-80" v-for="(unitChild, unitKey) in unitChildren" :key="`${key}${unitKey}`">{{ unitChild.name }}</th>
                            <th scope="col" class="width-80 bg-secondary" :key="`${key}`">Jumlah</th>
                        </template>

                        <th scope="col" class="width-80"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, key) in items">
                    <tr class="valign-middle" :key="`item-${key}`">
                        <td :rowspan="item.report_indicator_labels.length+1">{{ key+1 }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.indicator ? item.indicator.name : '-' }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.target_indicator_label }}</td>
                    </tr>
                    <tr class="valign-middle" :key="`detail-${key}-${detailKey}`" v-for="(detail, detailKey) in item.report_indicator_labels">
                        <!-- Data yang dilaporkan -->
                        <td class="text-center">{{ detailKey+1 }}</td>
                        <td>{{ detail.name }}</td>
                        <!-- Rekapitulasi -->
                        <template v-for="(_, monthKey) in months">
                            <td class="text-center" :key="`month-${key}-${detailKey}-${monthKey}-${unitKey}`"  v-for="(unitChild, unitKey) in unitChildren">
                                {{ values[key][detailKey][monthKey][unitKey] }}
                            </td>
                            <th scope="col" class="width-80 text-center" :key="`month-${key}-${detailKey}-${monthKey}`">
                                {{ sum(values[key][detailKey][monthKey]) }}
                            </th>
                        </template>
                        <th scope="col" class="text-center">{{ sum2Level(values[key][detailKey]) }}</th>
                    </tr>
                    <tr
                        v-if="item.result_label && item.result_formula"
                        class="valign-middle bg-secondary"
                        :key="`item-result-${key}`"
                    >
                        <td colspan="4"></td>
                        <th scope="col">Hasil ({{ item.result_label }})</th>
                        <template v-for="(month, monthKey) in months">
                            <th
                                scope="col"
                                class="text-center"
                                :key="`month-result-${key}-${monthKey}-${unitKey}`"
                                v-for="(unit, unitKey) in unitChildren"
                                v-html="resultLabels[key][monthKey][unitKey]">
                            </th>
                            <th
                                scope="col"
                                class="text-center"
                                :key="`month-result-${key}-${monthKey}`"
                                v-html="resultMonths[key][monthKey]">
                            </th>
                        </template>
                        <th scope="col" class="text-center">{{ resultFinals[key] }}</th>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InputFormDataParentView',
        props: {
            model: {
                type: Object,
                default: () => null
            },
            inputValues: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            months: {
                type: Array,
                default: () => []
            },
            monthLimit: Number,
            unitChildren: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                loading: true,
                values: [],
                resultLabels: [],
                resultMonths: [],
                resultFinals: [],
            }
        },
        computed: {
            unitNames() {
                return this.unitChildren.map((el) => el.name).join(', ')
            }
        },
        created() {
            let resultLabels = [],
                resultMonths = [],
                resultFinals = []
            this.items.map((item, key) => {
                let values = []
                item.report_indicator_labels.map((detail, detailKey) => {
                    let details = []
                    this.months.map((month, monthKey) => {
                        let units = []
                        this.unitChildren.map((unitChild, unitKey) => {
                            const inputValue = this.inputValues.find((val) =>
                                val.unit_id == unitChild.id &&
                                val.indicator_id == item.indicator_id &&
                                val.report_indicator_id == detail.report_indicator_id &&
                                val.input_year == this.model.year &&
                                val.input_month == monthKey + 1)
                            units[unitKey] = inputValue ? inputValue.value : ''
                        })
                        details[monthKey] = units
                    })
                    values[detailKey] = details
                })
                this.values.push(values) // Per Month

                let percentagesMonths = [],
                    resultMonth = []
                this.months.map((month, monthKey) => {
                    let percentageUnits = []
                    this.unitChildren.map((unitChild, unitKey) => {
                        let formula = item.result_formula
                        values.map((value, i) => {
                            const alphabet = this.alphabet(i)
                            let val = value[monthKey][unitKey] ? value[monthKey][unitKey] : 0
                            formula = formula.replace(`[${alphabet}]`, val)
                        })
                        percentageUnits[unitKey] = this.normalizeEval(formula)
                    })
                    percentagesMonths[monthKey] = percentageUnits

                    // total per months
                    let formula = item.result_formula
                    let formulaTotal = item.result_formula
                    values.map((detail, detailKey) => {
                        const alphabet = this.alphabet(detailKey)
                        let val = this.sum(detail[monthKey])
                        let total = this.sum2Level(detail)
                        formula = formula.replace(`[${alphabet}]`, val)
                        formulaTotal = formulaTotal.replace(`[${alphabet}]`, total)
                    })
                    resultMonth[monthKey] = this.normalizeEval(formula)
                    resultFinals[key] = this.normalizeEval(formulaTotal)
                })
                resultLabels[key] = percentagesMonths
                resultMonths[key] = resultMonth
            })
            this.loading = false
            this.resultLabels = resultLabels // Hasil per Indikator
            this.resultMonths = resultMonths
            this.resultFinals = resultFinals
        }
    }
</script>
